export default __webpack_public_path__ + "static/media/headerImg.24cc6e3a.png";